export default __webpack_public_path__ + "static/media/alec_johnson.bd2e742c.png";